import { stringToSlug } from "./helpers.js";

// `helpers` is the global debug bundle (src2/gulp/helpers.js), not this
// module's ./helpers.js. OptinMonster's callbacks fire on third-party
// `om.*` DOM events, which can run before that global bundle is present —
// so guard it the way HSFormEvents/ThryvQualified do, else: ReferenceError
// "helpers is not defined".
function omDebug() {
  return typeof helpers !== "undefined" && helpers.shouldDebug("headerSection");
}

var OptinMonster = {};

OptinMonster.init = function () {
  // Listen for show event
  document.addEventListener("om.Html.append.after", OptinMonster.onShow);

  // Listen for hide/close event
  document.addEventListener("om.Campaign.close", OptinMonster.onHide);

  // Listen for resize
  window.addEventListener("resize", OptinMonster.onResize);
};

OptinMonster.onShow = function (event) {
  if (omDebug()) console.log("[HeaderSection.OptinMonster] onShow");
  OptinMonster.currentBannerID = "om-" + event.detail.Campaign.id;
  OptinMonster.currentName = event.detail.Campaign.data.name;

  // Set attribute on <html>
  document.documentElement.setAttribute("data-om-cname", stringToSlug(OptinMonster.currentName));

  // Update header height
  OptinMonster.setHeaderHeight(OptinMonster.currentBannerID);
};

OptinMonster.onHide = function (event) {
  if (omDebug()) console.log("[HeaderSection.OptinMonster] onHide");
  var bannerID = "om-" + event.detail.Campaign.id;
  var name = event.detail.Campaign.data.name;

  if (omDebug()) console.log("[HeaderSection.OptinMonster] banner closed:", "#" + bannerID, name);

  // Optionally reset the header offset
  var headerEl = document.querySelector(".header-sections");
  if (headerEl) {
    headerEl.style.setProperty("--header-top-pos", "0px");
  }
};

OptinMonster.onResize = function () {
  if (!OptinMonster.currentBannerID) return;

  var bannerEl = document.getElementById(OptinMonster.currentBannerID);
  if (bannerEl && bannerEl.offsetParent !== null) {
    // visible check
    if (omDebug())
      console.log("[HeaderSection.OptinMonster] resize", "#" + OptinMonster.currentBannerID);
    OptinMonster.setHeaderHeight(OptinMonster.currentBannerID);
  }
};

OptinMonster.setHeaderHeight = function (bannerID) {
  if (omDebug()) console.log("[HeaderSection.OptinMonster] setHeaderHeight", bannerID);
  var headerEl = document.querySelector(".header-sections");
  if (!headerEl) return;

  setTimeout(function () {
    var bannerEl = document.getElementById(bannerID);
    var adminBarEl = document.getElementById("wpadminbar");
    if (!bannerEl) return;

    var adminBarHeight = adminBarEl ? adminBarEl.offsetHeight : 0;
    var bannerHeight = bannerEl.offsetHeight + adminBarHeight;

    if (omDebug()) console.log("[HeaderSection.OptinMonster] bannerHeight:", bannerHeight);

    headerEl.style.setProperty("--header-top-pos", bannerHeight + "px");
  }, 500);
};

export default OptinMonster;
